export default "__VITE_ASSET__v2HyToZj__"